module.exports = __webpack_public_path__ + "static/media/68.0f43f64b.png";